// extracted by mini-css-extract-plugin
module.exports = {"progress":"Loading_progress__1pqxH"};